import { useQuery } from '@tanstack/react-query';
import { HTTPError } from 'ky';
import { z } from 'zod';

import { apiClient } from '@/lib/api/client';

import { customizationKeys } from './customizationKeys';

// Wire shape for GET /api/v1/tenants/me/customization (backend TenantCustomizationDto).
export const tenantCustomizationSchema = z.object({
  id: z.string(),
  customizationJson: z.string().nullable(),
  logoUrl: z.string().nullable(),
});

export type TenantCustomization = z.infer<typeof tenantCustomizationSchema>;

// GET the caller's tenant branding. 404 (platform-only user / no tenant) maps
// to null so the screen can render a hidden/empty state without try/catch.
export function useGetCustomization() {
  return useQuery({
    queryKey: customizationKeys.current(),
    queryFn: async ({ signal }) => {
      try {
        const raw = await apiClient.get('api/v1/tenants/me/customization', { signal }).json();
        return tenantCustomizationSchema.parse(raw);
      } catch (error) {
        if (error instanceof HTTPError && error.response.status === 404) {
          return null;
        }
        throw error;
      }
    },
    staleTime: 60_000,
    retry: false,
  });
}
